import React from "react";
// import TableComandas from "../components/TableComandas";
import AppMovReactTable from "../table/AppMovReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const Movs = () => {
  return (
    <>
      <AppMovReactTable />
      {/* <TableComandas /> */}
      <Footer />
    </>
  );
};

export default Movs;
